import { logUsage } from '../analytics/analytics';
import { INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT } from 'owa-analytics-types';

/**
 * The serialize function will replace the existing value with an object that contains
 * the issue type (so we know how to deserialize it) and the serialized value.
 */
export function serialize(obj: any): any {
    try {
        return JSON.parse(JSON.stringify(obj, customStringify));
    } catch (caught) {
        const e = caught instanceof Error ? caught : undefined;
        /* eslint-disable-next-line owa-custom-rules/telemetry-no-global-account-routing -- (https://aka.ms/OWALintWiki)
         * Justification: Worker infrastructure code has no mailbox context - serialization runs across all mailboxes. */
        logUsage?.('ObjectSerializationFailed', INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT, {
            message: e?.message,
            stack: e?.stack,
        });

        return null;
    }
}

function customStringify(_key: string, value: any) {
    if (value instanceof Error) {
        return stringifyError(value);
    } else if (typeof value?.then === 'function') {
        return undefined;
    }

    return value;
}

function stringifyError(value: any) {
    const error: {
        [key: string]: any;
    } = {};
    const errorKeys = Object.getOwnPropertyNames(value);

    for (const name of errorKeys) {
        const isNumber = typeof value[name] === 'number';
        const isString = typeof value[name] === 'string';
        if (value[name] || isNumber) {
            error[name] = isString || isNumber ? value[name] : JSON.stringify(value[name]);
        }
    }

    return error;
}
